export const PLATFORM_META = {
  twitter_thread: {
    label: "X / Twitter Thread",
    short: "Twitter Thread",
    description: "6–12 numbered tweets, hook-first",
  },
  linkedin_post: {
    label: "LinkedIn Post",
    short: "LinkedIn Post",
    description: "Professional, structured, human",
  },
  linkedin_carousel: {
    label: "LinkedIn Carousel",
    short: "LI Carousel",
    description: "Slide-by-slide, one idea each",
  },
  instagram_caption: {
    label: "Instagram Caption",
    short: "IG Caption",
    description: "Casual, engaging, with hashtags",
  },
  email_newsletter: {
    label: "Email Newsletter",
    short: "Newsletter",
    description: "Subject line + body + CTA",
  },
};

export const ALL_PLATFORMS = Object.keys(PLATFORM_META);
